<template lang="pug">
  .b-crm-funnel-member-list-ui
    h2._title Участники воронки
    p._description Участники видят заявки воронки и работают с ними. Управлять структурой воронки могут только владелец компании и его заместители
    ._list(v-if="members.length")
      ._row(v-for="member in members" :key="member.key")
        UserTile._user(:user="member.user" :size="40")
        //- пока участник не сохранён, удалять нечего: id придёт с сервера
        button._action(
          v-if="canManage"
          type="button"
          :class="{ disabled: member.pending }"
          :disabled="member.pending"
          :title="member.pending ? 'Сохраняется' : 'Убрать из воронки'"
          @click="$emit('remove', member)"
        )
          Icon(name="trash" pointer colored)
    EmptyList(v-else) В воронке пока нет участников
    ._footer
      Btn._add(v-if="canManage" sm green type="button" @click="$emit('add')") Добавить участника
      RequestIndicator._indicator(v-if="saving !== null" :loading="saving")
</template>

<script>
import UserTile from '@/components/UserTile.vue';
import EmptyList from '@/components/ui/EmptyList.vue';

export default {
  name: 'CrmFunnelMemberListUi',
  components: { UserTile, EmptyList },
  // UserTile берёт подпись под именем из инжектируемой функции positions,
  // ключ — id пользователя; здесь это должность сотрудника в компании
  provide() {
    return {
      positions: () => Object.fromEntries(
        this.members
          .filter(member => member.position)
          .map(member => [member.user.id, member.position]),
      ),
    };
  },
  props: {
    members: {
      type: Array,
      required: true,
    },
    // null — показывать нечего, true — запрос идёт, false — сохранено
    saving: {
      type: Boolean,
      default: null,
    },
    // добавление и исключение участников — только у владельца компании и
    // заместителя, участник воронки видит один лишь состав
    canManage: Boolean,
  },
};
</script>

<style scoped lang="scss">
.crm-funnel-member-list-ui {
  width: 462px;
  max-width: 100%;

  &__title {
    font-weight: 700;
    font-size: 18px;
    color: var(--color-dark-gray);
    margin-bottom: 12px;
  }

  &__description {
    font-size: 12px;
    line-height: 1.4;
    color: var(--color-middle-gray);
    margin-bottom: 20px;
  }

  &__list {
    display: flex;
    flex-direction: column;
  }

  &__row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 4px;
    border-bottom: 1px solid var(--color-purple);

    &:last-child {
      border-bottom: none;
    }
  }

  &__user {
    flex-grow: 1;
    min-width: 0;
  }

  &__action {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    background: none;
    border: none;
    padding: 0;
    color: var(--color-middle-gray);
    cursor: pointer;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.7;
    }

    &.disabled {
      opacity: 0.35;
      cursor: default;
      pointer-events: none;
    }

    svg {
      width: auto;
      height: 16px;
    }
  }

  &__footer {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-top: 20px;
  }

  &__indicator {
    margin-left: auto;
  }
}
</style>
